import axios, { AxiosError } from "axios";

export const apiGet = async (api: string): Promise<any> => {
  try {
    const accessToken = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${process.env.REACT_APP_API_SERVER}/api${api}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 401) {
        const refreshToken = sessionStorage.getItem("refreshToken");

        // refreshToken이 없으면 로그아웃 처리
        if (!refreshToken) {
          console.error("No refresh token, logging out");
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refreshToken");
          window.location.href = "/";
          return { error: "No refresh token" };
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_SERVER}/api/user/refresh`,
          { refreshToken }
        );

        // Aceess Token 갱신 실패
        if (response.data.error) {
          console.error("refresh token error", response.data.error);
          // 토큰 갱신 실패 시 로그아웃 처리
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refreshToken");
          window.location.href = "/";
          return response.data;
        }

        const accessToken = response.data.data;
        sessionStorage.setItem("accessToken", accessToken);

        return await apiGet(api);
      }
    }
    return "";
  }
};

export const apiPost = async (
  api: string,
  payload?: any,
  isMultiPart = false,
  isBlob = false
): Promise<any> => {
  try {
    const accessToken = sessionStorage.getItem("accessToken");

    let headers = {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      responseType: "application/json",
    };

    if (isMultiPart) {
      headers = { ...headers, "Content-Type": "multipart/form-data" };
    }

    const responseType = isBlob ? "blob" : "json";

    const response = await axios.post(
      `${process.env.REACT_APP_API_SERVER}/api${api}`,
      payload,
      { headers, responseType }
    );

    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 401) {
        const refreshToken = sessionStorage.getItem("refreshToken");
        console.error("401", refreshToken);

        // refreshToken이 없으면 로그아웃 처리
        if (!refreshToken) {
          console.error("No refresh token, logging out");
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refreshToken");
          window.location.href = "/";
          return { error: "No refresh token" };
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_SERVER}/api/user/refresh`,
          { refreshToken: refreshToken }
        );

        // Aceess Token 갱신 실패
        if (response.data.error) {
          console.error("refresh token error", response.data.error);
          // 토큰 갱신 실패 시 로그아웃 처리
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refreshToken");
          window.location.href = "/";
          return response.data;
        }

        const accessToken = response.data.data;
        sessionStorage.setItem("accessToken", accessToken);

        return await apiPost(api, payload, isMultiPart);
      }
    }
    return "";
  }
};

export const apiPut = async (
  api: string,
  data?: any,
  isMultiPart = false
): Promise<any> => {
  try {
    const accessToken = sessionStorage.getItem("accessToken");

    const headers = isMultiPart
      ? {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        }
      : {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        };

    const response = await axios.put(
      `${process.env.REACT_APP_API_SERVER}/api${api}`,
      data,
      { headers }
    );

    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 401) {
        const refreshToken = sessionStorage.getItem("refreshToken");

        // refreshToken이 없으면 로그아웃 처리
        if (!refreshToken) {
          console.error("No refresh token, logging out");
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refreshToken");
          window.location.href = "/";
          return { error: "No refresh token" };
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_SERVER}/api/user/refresh`,
          { refreshToken: refreshToken }
        );

        // Aceess Token 갱신 실패
        if (response.data.error) {
          console.error("refresh token error", response.data.error);
          // 토큰 갱신 실패 시 로그아웃 처리
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refreshToken");
          window.location.href = "/";
          return response.data;
        }

        const accessToken = response.data.data;
        sessionStorage.setItem("accessToken", accessToken);

        return await apiPut(api, data, isMultiPart);
      }
    }
    return "";
  }
};

export const apiDelete = async (api: string): Promise<any> => {
  try {
    const accessToken = sessionStorage.getItem("accessToken");

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    };

    const response = await axios.delete(
      `${process.env.REACT_APP_API_SERVER}/api${api}`,
      { headers }
    );

    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 401) {
        const refreshToken = sessionStorage.getItem("refreshToken");

        // refreshToken이 없으면 로그아웃 처리
        if (!refreshToken) {
          console.error("No refresh token, logging out");
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refreshToken");
          window.location.href = "/";
          return { error: "No refresh token" };
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_SERVER}/api/user/refresh`,
          { refreshToken: refreshToken }
        );

        // 로그인 오류
        // Aceess Token 갱신 실패
        if (response.data.error) {
          console.error("refresh token error", response.data.error);
          // 토큰 갱신 실패 시 로그아웃 처리
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refreshToken");
          window.location.href = "/";
          return response.data;
        }

        const accessToken = response.data.data;
        sessionStorage.setItem("accessToken", accessToken);

        return await apiDelete(api);
      }
    }
    return "";
  }
};

export const apiPostWithRefreshToken = async (api: string, data?: any) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.post(
      // process.env.REACT_APP_API_SERVER + api,
      `${process.env.REACT_APP_API_SERVER}/api${api}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {}
};
